export default __webpack_public_path__ + "static/media/Linero2Open.1538caf0.png";